<p-modal [open]="open" (dismiss)="close()">
  <p-heading slot="header" [size]="'large'" [tag]="'h2'">
    Add New Edu Transaction Category
  </p-heading>

  <form class="form" [formGroup]="form" [id]="formId" (ngSubmit)="submit()">
    <p-select-wrapper
      *ngrxLet="form.controls.budgetType as control"
      [filter]="true"
      [label]="'Budget Type'"
      [message]="control.errors?.['message'] ?? ''"
      [state]="control.touched && control.errors ? 'error' : 'none'"
    >
      <select [attr.required]="true" [formControl]="control">
        <option *ngFor="let type of budgetTypes" [value]="type">
          {{ budgetTypeTranslation[type] | transloco }}
        </option>
      </select>
    </p-select-wrapper>

    <p-text-field-wrapper
      *ngrxLet="form.controls.name as control"
      [label]="'Category Name'"
      [message]="control.errors?.['message'] ?? ''"
      [state]="control.touched && control.errors ? 'error' : 'none'"
    >
      <input type="text" [attr.required]="true" [formControl]="control" />
    </p-text-field-wrapper>

    <p-text-field-wrapper
      *ngrxLet="form.controls.description as control"
      [label]="'Category Description'"
      [message]="control.errors?.['message'] ?? ''"
      [state]="control.touched && control.errors ? 'error' : 'none'"
    >
      <input type="text" [attr.required]="true" [formControl]="control" />
    </p-text-field-wrapper>
  </form>

  <p-button-group slot="footer">
    <p-button [form]="formId" [loading]="(submitting$ | async) ?? false" [type]="'submit'">
      Add
    </p-button>
    <p-button [iconSource]="'assets/icons/close.svg'" [variant]="'secondary'" (click)="close()">
      Close
    </p-button>
  </p-button-group>
</p-modal>
